import { render, staticRenderFns } from "./modificacion-composicion-familiar-correccion.vue?vue&type=template&id=f971a434&"
import script from "./modificacion-composicion-familiar-correccion.vue?vue&type=script&lang=ts&"
export * from "./modificacion-composicion-familiar-correccion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports